import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './whatsapp';
import ImagePopup from './ImagePopup';
import Chat from './chat';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import {Helmet} from 'react-helmet';
import Call from './call';
import Swiper from './swiper';
import Marquee from './marquee';
import './homeVideoModal.css';


function Home() {
 const [testimonial,settestimonial]=useState([]);
 const [aboutus,setaboutus]=useState([]);
  const [latest,setlatest]=useState([]);
  const [completed,setcompleted]=useState([]);
   const [city,setcity]=useState([]);
   const [banner,setbanner]=useState([]);
   const [projects,setprojects]=useState([]);
   const [affordable,setaffordable]=useState([]);
   const [showreferal,setshowreferalmodal]=useState(false);
  const [phone,setphone]=useState(null);
  const [showabout,setshowabout]=useState(false);
  const [showVideo,setShowVideo]=useState(false);

  const onrefer=async()=>{
   try {
    const res = await axios.post(
      "https://api.squareandangle.pranatigroup.in/api/admin/referandearn",
      {
        phone,
      }
    );

    alert(res.data.message);
    setphone("");
    setshowreferalmodal(false);
   } catch (error) {
    console.log(error);

    alert("Failed to save referral");
   }
   }
  

  useEffect(()=>{
    const fetchTestimonial=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/testimonial`);
     settestimonial(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchAbout=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/about`);
     setaboutus(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchLatest=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/latest`);
     setlatest(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchCompleted=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/completed`);
     setcompleted(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchCty=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/cityproject`);
     setcity(res.data);
      }catch(error){
      console.error(error);
      }
    }
    const fetchBanner=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/banner`);
     setbanner(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchinterior=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/pj`);
     setprojects(res.data);
      }catch(error){
      console.error(error);
      }
    }
    const fetchaffordable=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/affordable`);
     setaffordable(res.data);
      }catch(error){
      console.error(error);
      }
    }
    fetchinterior();
    fetchBanner();
    fetchCty();
    fetchCompleted();
    fetchLatest();
    fetchAbout();
  fetchTestimonial();
  fetchaffordable();
  },[]);
return (
    <>
    <div className="App">

    <Header />
    <Marquee/>

     <Helmet>
            <title>Pranati Interior - Kolkata best Interior</title>
            <meta name="description" content="Welcome to Kolkata best interior" />
    
            <link rel="canonical" href="https://squareandangle.pranatigroup.in/Home" />
    
            <meta property="og:title" content="Pranati interior" />
            <meta property="og:description" content="Kolkata best Interior" />
            <meta property="og:image" content="/images/preview.png" />
            <meta property="og:url" content="https://squareandangle.pranatigroup.in/Home" />
    
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Pranati interior" />
            <meta name="twitter:description" content="Kolkata best Interior" />
            <meta name="twitter:image" content="/images/preview.png" />
    
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Pranati Interior",
                "url": "https://squareandangle.pranatigroup.in/Home",
                "description": "Kolkata best Interior",
                "image": "https://squareandangle.pranatigroup.in/images/preview.png",
                "areaServed": "Kolkata",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Kolkata",
                  "addressRegion": "West Bengal",
                  "addressCountry": "IN"
                }
              })}
            </script>
          </Helmet>
        
   
    <div className="slider-area slider-area2" style={{position: "relative"}}>
       

            <div style={{

            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 100

            }}>
                <ImagePopup/>
        </div>
        <div className="slider-active2 next-prev-style">

          {banner.map((item, idx)=>(
            <div
              className="slider-items"
              key={item.id ?? idx}
              style={{ backgroundImage: item.banner ? `url(${uploadUrl(item.banner)})` : undefined }}
            >
              <img src={uploadUrl(item.banner)} alt={item.banner_text || "Pranati Interior Design"} className="slider" />
              <div className="slider-content">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-10 offset-lg-1 col-12">
                      <div className="slider-text text-center">
                        <div className="line"></div>
                        <h2>
                         <span className="color">Kolkata</span>
                        </h2>
                        <p style={{color:"white"}}>{item.banner_text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

        </div>

      
    </div>


   
  
   
    <div className="about-area about-area2 ptb-120">
        <div className="container">
            {aboutus.map((item)=>(

            <div className="row">
                <div className="col-lg-6 col-12 d-none d-sm-block">
                    <div className="about-img2">
                        
                        <div className="about-images">
                            
                            <img src={uploadUrl(item.image)}
                            style={{
        width: "500px",
        height: "350px",
        objectFit: "cover",
        display: "block"
    }}
                            alt="interior designer cost kolkata"/>
                           
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-12">
                    <div className="about-wrap">
                        <h2>Paranti Interior</h2>
                        <h3>{item.title}.</h3>
                        <p>{item.description}.</p>
                        <div className="row">
                            <div className="col-md-4 col-sm-6 col-12">
                                <div
                                    className="about-content"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        minHeight: "150px"
                                    }}
                                >
                                    <h4>
                                        <span className="counter">07</span>
                                        <span> + </span>
                                    </h4>
                                    <p>Experience Years</p>
                                </div>
                            </div>

                            <div className="col-md-4 col-sm-6 col-12">
                            <div
                                className="about-content"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    minHeight: "150px"
                                }}
                            >
                                <h4>
                                    <span className="counter">280</span>
                                    <span> + </span>
                                </h4>
                                <p>Happy Customers</p>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </div>
            ))}
        </div>
    </div>


    {/* <div className="service-area bg-1">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="section-title text-center">
                        <h2>Best Interior Designer Decorator Kolkata</h2>
                        <h3>Given the growing demand for quality interior design services in Kolkata with Affordable Price</h3>
                    </div>
                </div>
            </div>
            <div className="row">
               
              {projects.slice(0,9).map((item, index) => (
  <div className="col-sm-6 col-12 col-lg-4" key={item.id || index}>
    
    <div
      className="service-wrap"
      style={{
        position: "relative",
        overflow: "hidden",
        borderRadius: "10px",
      }}
    >

      <div
        style={{
          position: "absolute",
          top: "15px",
          left: "15px",
          background: "#ef5b78",
          color: "#fff",
          padding: "8px 14px",
          borderRadius: "30px",
          fontSize: "14px",
          fontWeight: "700",
          zIndex: 10,
          boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
        }}
      >
       Discount
      </div>

      <div className="service-img">
        <img
          src={uploadUrl(item.image)}
          alt="industrial interior designers kolkata"
        />
      </div>

      <div className="service-content">
        <h4>{item.title}</h4>

        <p>{item.description}</p>

        <a
          href="https://wa.me/06289001010?text=Hello%20I%20want%20more%20details"
          target="_blank"
          rel="noopener noreferrer"
          className="readMoreBtn"
         
        >
          Read More
        </a>
      </div>
    </div>

  </div>
))}
               


            </div>
        </div>
    </div> */}



<section
    style={{
        width: "100%",
        padding: "100px 0",
        background: "#fff",
        overflow: "hidden",
    }}
>
    <div
        className="container"
        style={{
            maxWidth: "1400px",
            paddingLeft: "20px",
            paddingRight: "20px",
        }}
    >

        
        <div
            style={{
                textAlign: "center",
                maxWidth: "800px",
                margin: "0 auto 60px",
            }}
        >
            <div
                style={{
                    color: "#a17c4b",
                    fontSize: "12px",
                    fontWeight: "700",
                    letterSpacing: "3px",
                    textTransform: "uppercase",
                    marginBottom: "15px",
                    fontFamily: "Arial, sans-serif",
                }}
            >
                OUR EXPERTISE
            </div>

            <h2
                style={{
                    margin: "0 0 18px",
                    color: "#171717",
                    fontFamily: "Georgia, serif",
                    fontSize: "clamp(32px, 5vw, 62px)",
                    fontWeight: "500",
                    lineHeight: "1.1",
                    letterSpacing: "-1px",
                }}
            >
                End-to-End Interior Solutions
            </h2>

            <p
                style={{
                    margin: "0",
                    color: "#555",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "1.9",
                    letterSpacing: "0.3px",
                }}
            >
                From concept to completion, we create sophisticated interiors
                that seamlessly blend{" "}
                <span
                    style={{
                        color: "#9b7a4a",
                        fontWeight: "600",
                    }}
                >
                    functionality, comfort, and timeless design
                </span>{" "}
                — delivering spaces that are built to inspire and endure.
            </p>

            <div
                style={{
                    width: "55px",
                    height: "2px",
                    background: "#a17c4b",
                    margin: "25px auto 0",
                }}
            />
        </div>

      
        <div className="row g-3">

           
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end.jpeg"
                        alt="Luxury Living Space"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Living Spaces
                        </h3>
                    </div>
                </div>
            </div>

           
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end2.jpeg"
                        alt="Modern Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Modern Interiors
                        </h3>
                    </div>
                </div>
            </div>

          
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end3.jpeg"
                        alt="Premium Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Premium Spaces
                        </h3>
                    </div>
                </div>
            </div>

           
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end5.jpeg"
                        alt="Contemporary Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Contemporary Design
                        </h3>
                    </div>
                </div>
            </div>

          
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end6.jpeg"
                        alt="Elegant Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Elegant Interiors
                        </h3>
                    </div>
                </div>
            </div>

           
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end7.jpeg"
                        alt="Corporate Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Corporate Spaces
                        </h3>
                    </div>
                </div>
            </div>

           
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end8.jpeg"
                        alt="Luxury Home Interior"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Luxury Homes
                        </h3>
                    </div>
                </div>
            </div>

            
            <div className="col-12 col-sm-6 col-lg-3">
                <div
                    style={{
                        position: "relative",
                        height: "400px",
                        overflow: "hidden",
                        background: "#ddd",
                    }}
                >
                    <img
                        src="/assets/images/end9.jpeg"
                        alt="Complete Interior Solution"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            transition: "transform 0.6s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                        }
                    />

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(to top, rgba(0,0,0,.75), transparent 65%)",
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            bottom: "25px",
                            left: "25px",
                            right: "20px",
                            color: "#fff",
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontFamily: "Georgia, serif",
                                fontSize: "23px",
                                fontWeight: "400",
                            }}
                        >
                            Complete Solutions
                        </h3>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>


   
    
  
    <div
    style={{
        padding: "100px 0",
        background: "#fff"
    }}
>
    <div className="container">
        <div className="row align-items-center">

            <div className="col-lg-7">
                <div style={{ paddingRight: "45px" }}>

                    <div style={{ marginBottom: "35px" }}>
                        <span
                            style={{
                                display: "inline-block",
                                marginBottom: "10px",
                                color: "#a47b42",
                                fontSize: "12px",
                                fontWeight: "700",
                                letterSpacing: "2px",
                                textTransform: "uppercase"
                            }}
                        >
                            Investment Guide
                        </span>

                        <h2
                            style={{
                                margin: "0 0 12px",
                                color: "#202020",
                                fontSize: "44px",
                                fontWeight: "700",
                                lineHeight: "1.2"
                            }}
                        >
                            Starting Cost
                        </h2>

                        <p
                            style={{
                                maxWidth: "570px",
                                margin: "0",
                                color: "#777",
                                fontSize: "15px",
                                lineHeight: "1.8"
                            }}
                        >
                            Explore our estimated starting prices for
                            residential, commercial, and office interior
                            projects.
                        </p>
                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px"
                        }}
                    >

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    3 BHK Residential Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹12–15 Lac
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "90%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    4 BHK Residential Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹20 Lac+
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "95%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    2 BHK Residential Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹7–10 Lac
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "85%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    1 BHK Interior Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹3–5 Lac
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "80%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    Shop Interior Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹3 Lac
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "70%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "20px 22px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "7px",
                                boxShadow: "0 5px 20px rgba(0,0,0,0.03)"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "12px"
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "600"
                                    }}
                                >
                                    Office Interior Decoration
                                </span>

                                <strong
                                    style={{
                                        color: "#a47b42",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    ₹2.5 Lac
                                </strong>
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    height: "7px",
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        width: "65%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, #8f6b3d, #c19a62)",
                                        borderRadius: "20px"
                                    }}
                                />
                            </div>
                        </div>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "25px"
                        }}
                    >
                        <span style={{ color: "#ad844d" }}>●</span>

                        <p
                            style={{
                                margin: 0,
                                color: "#888",
                                fontSize: "12px",
                                lineHeight: "1.6"
                            }}
                        >
                            Final pricing may vary depending on design,
                            materials, area, and project requirements.
                        </p>
                    </div>

                </div>
            </div>

           
            <div className="col-lg-5">
                <div
                    style={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "10px",
                        boxShadow: "0 20px 50px rgba(0,0,0,0.15)"
                    }}
                >
                    <img
                        src="./assets/images/downloadweb.png"
                        alt="Interior Design"
                        style={{
                            display: "block",
                            width: "100%",
                            height: "620px",
                            objectFit: "cover"
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            padding: "80px 30px 30px",
                            color: "#fff",
                            background:
                                "linear-gradient(to top, rgba(0,0,0,0.75), transparent)"
                        }}
                    >
                        <span
                            style={{
                                display: "block",
                                marginBottom: "8px",
                                color: "#d2af78",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "2px",
                                textTransform: "uppercase"
                            }}
                        >
                            Premium Interiors
                        </span>

                        <strong
                            style={{
                                display: "block",
                                fontSize: "24px",
                                fontWeight: "600"
                            }}
                        >
                            Designed Around You
                        </strong>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

   
 <div
    className="team-area"
    style={{
        padding: "60px 0",
        background: "#f7f7f7"
    }}
>
    <div className="container">

       
        <div className="row">
            <div className="col-12">
                <div
                    className="section-title text-center"
                    style={{ marginBottom: "40px" }}
                >
                    <h2
                        style={{
                            fontSize: "36px",
                            fontWeight: "700",
                            color: "#1c1c1c",
                            marginBottom: "10px"
                        }}
                    >
                       Location wise projects
                    </h2>

                    <h3
                        style={{
                            fontSize: "17px",
                            fontWeight: "400",
                            color: "#777",
                            margin: 0
                        }}
                    >
                        Lowest Price Best Interior Designing Services Provider In Kolkata West Bengal
                    </h3>
                </div>
            </div>
        </div>

        
        <div className="row">

            {city.map((item, index) => (
                <div
                    className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6"
                    key={index}
                    style={{ marginBottom: "25px" }}
                >
                    <div
                        style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                            borderRadius: "5px",
                            overflow: "hidden",
                            height: "100%"
                        }}
                    >

                       
                        <div
                            style={{
                                width: "100%",
                                height: "260px",
                                overflow: "hidden"
                            }}
                        >
                            <img
                                src={uploadUrl(item.images)}
                                title={`${item.design} | Pranati Interior`}
                                alt={item.design}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block"
                                }}
                            />
                        </div>

                       
                        <div
                            style={{
                                padding: "18px",
                                textAlign: "center"
                            }}
                        >
                            <h4
                                style={{
                                    fontSize: "19px",
                                    lineHeight: "1.3",
                                    fontWeight: "600",
                                    color: "#222",
                                    margin: "0 0 6px"
                                }}
                            >
                                {item.design}
                            </h4>

                            <p
                                style={{
                                    fontSize: "14px",
                                    color: "#777",
                                    margin: "0 0 15px"
                                }}
                            >
                                {item.city}
                            </p>

                            
                            

                        </div>
                    </div>
                </div>
            ))}

        </div>
    </div>
</div>

   
    <div
    style={{
        width: "100%",
        padding: "90px 0",
        background: "#171717",
        position: "relative",
        overflow: "hidden",
    }}
>
    <div
        style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "3px",
            background:
                "linear-gradient(90deg, transparent, #b08b57, transparent)",
        }}
    />

    <div
        className="container"
        style={{
            maxWidth: "1200px",
            paddingLeft: "15px",
            paddingRight: "15px",
        }}
    >
        <div
            className="row align-items-center"
            style={{
                margin: "0",
                padding: "50px",
                background: "#1e1e1e",
                border: "1px solid rgba(255,255,255,0.12)",
                position: "relative",
            }}
        >

            <div className="col-lg-9 col-md-8 col-12">
                <div
                    style={{
                        paddingRight: "20px",
                    }}
                >
                  
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "18px",
                        }}
                    >
                        <span
                            style={{
                                display: "block",
                                width: "35px",
                                height: "1px",
                                background: "#b08b57",
                                flexShrink: 0,
                            }}
                        />

                        <span
                            style={{
                                color: "#b08b57",
                                fontFamily: "Arial, sans-serif",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "3px",
                                textTransform: "uppercase",
                            }}
                        >
                            LET'S CREATE TOGETHER
                        </span>
                    </div>

                    <h2
                        style={{
                            margin: "0 0 18px",
                            color: "#ffffff",
                            fontFamily: "Georgia, serif",
                            fontSize: "clamp(30px, 4vw, 50px)",
                            fontWeight: "400",
                            lineHeight: "1.15",
                            letterSpacing: "-0.5px",
                        }}
                    >
                        Transform Your Space
                        <br />

                        <span
                            style={{
                                color: "#b08b57",
                            }}
                        >
                            With Exceptional Design
                        </span>
                    </h2>

                    <p
                        style={{
                            maxWidth: "700px",
                            margin: "0",
                            color: "#b8b8b8",
                            fontFamily:
                                "Arial, Helvetica, sans-serif",
                            fontSize: "15px",
                            fontWeight: "400",
                            lineHeight: "1.8",
                        }}
                    >
                        From concept to completion, our interior design
                        experts create refined and functional spaces
                        tailored to your lifestyle, brand, and budget
                        across Kolkata, Howrah, and West Bengal.
                    </p>
                </div>
            </div>

            <div
                className="col-lg-3 col-md-4 col-12"
                style={{
                    textAlign: "center",
                }}
            >
                <div
                    style={{
                        marginTop: "25px",
                    }}
                >
                    <a
                        href="https://api.whatsapp.com/send?phone=06289001010&text=Hi,%20Pranati%20Interior%20I%20Am%20Interested%20In%20Your%20Home%20Page!%20Need%20More%20Support"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            maxWidth: "190px",
                            padding: "16px 25px",
                            background: "#b08b57",
                            color: "#ffffff",
                            textDecoration: "none",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "11px",
                            fontWeight: "700",
                            letterSpacing: "1.5px",
                            textTransform: "uppercase",
                            border: "1px solid #b08b57",
                            boxSizing: "border-box",
                        }}
                    >
                        Get a Quote

                        <span
                            style={{
                                marginLeft: "12px",
                                fontSize: "18px",
                                lineHeight: "1",
                            }}
                        >
                            →
                        </span>
                    </a>

                    <div
                        style={{
                            marginTop: "12px",
                            color: "#777",
                            fontSize: "11px",
                            fontFamily: "Arial, sans-serif",
                        }}
                    >
                        Free Initial Consultation
                    </div>
                </div>
            </div>

            <div
                style={{
                    position: "absolute",
                    bottom: "-1px",
                    left: "-1px",
                    width: "40px",
                    height: "40px",
                    borderLeft: "2px solid #b08b57",
                    borderBottom: "2px solid #b08b57",
                }}
            />

            <div
                style={{
                    position: "absolute",
                    top: "-1px",
                    right: "-1px",
                    width: "40px",
                    height: "40px",
                    borderTop: "2px solid #b08b57",
                    borderRight: "2px solid #b08b57",
                }}
            />

        </div>
    </div>
</div>
    
    <div className="project-area">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-12">
    <div
        className="section-title"
        style={{
            textAlign: "center",
            marginBottom: "40px"
        }}
    >
        <h2
            style={{
                margin: "0",
                fontSize: "42px",
                fontWeight: "600",
                color: "#171717",
                lineHeight: "1.2"
            }}
        >
            Latest Projects
        </h2>
    </div>
</div>

                
                
            </div>
             <div className="row grid">

            {latest.map((item, index) => (

                <div
                    className="col-lg-4 col-md-6 col-sm-6 col-12 project cat2 cat4"
                    key={item.id || index}
                    style={{
                        marginBottom: "28px"
                    }}
                >

                    <div
                        style={{
                            background: "#fff",
                            border: "1px solid #e8e8e8",
                            overflow: "hidden",
                            height: "100%"
                        }}
                    >

                       
                        <div
                            style={{
                                position: "relative",
                                width: "100%",
                                height: "310px",
                                overflow: "hidden",
                                background: "#eee"
                            }}
                        >
                            <img
                                src={uploadUrl(item.project)}
                                alt={
                                    item.title ||
                                    "Corporate interior design project"
                                }
                                loading="lazy"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    objectFit: "cover",
                                    transform: "none"
                                }}
                            />

                          
                        </div>

                      
                    </div>
                </div>

            ))}

        </div>
        </div>
    </div>
  
    
   <div className="team-area">
    <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="section-title text-center">
                    <h2>Our Completed Projects</h2>
                    <h3>
                        A wall for our completed projects glory and a place to find more
                    </h3>
                </div>
            </div>
        </div>

        <div className="row">
            {completed.map((item, index) => (
                <div
                    className="col-lg-3 col-md-4 col-sm-6 col-12"
                    key={index}
                    style={{
                        marginBottom: "30px"
                    }}
                >
                    <div
                        className="team-wrap"
                        style={{
                            overflow: "hidden",
                            height: "100%"
                        }}
                    >
                        <div
                            className="team-img"
                            style={{
                                width: "100%",
                                height: "350px",
                                overflow: "hidden"
                            }}
                        >
                            <img
                                src={uploadUrl(item.project)}
                                alt="2 bhk house interior howrah"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block"
                                }}
                            />
                        </div>

                        

                        {/* <div
                            className="team-content"
                            style={{
                                textAlign: "center"
                            }}
                        >
                            <h4>{item.design}</h4>
                            <p>{item.name}</p>
                        </div> */}
                    </div>
                </div>
            ))}
        </div>
    </div>
</div>


    
   
   
   


   
  
   
    <div className="blog-area">

        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="section-title text-center">
                        <h2>Interiors Designed Around Your Budget</h2>
                        <h3>Every home has different priorities, lifestyles and investment levels. Explore our interior design categories to find the right balance of design, functionality, materials and detailing for your space.</h3>
                    </div>
                </div>
            </div>
            <div className="row">
       {affordable.map((item) => (
  <div className="col-lg-4 col-sm-6 col-12" key={item.id}>
    <div className="blog-wrap">
      <div className="blog-img">
        <img src={uploadUrl(item.image)} alt={item.title} />
      </div>
      <div className="blog-content">
        <h4>
          <a href={uploadUrl(item.image)} target="_blank" rel="noopener noreferrer">
            {item.title}
          </a>
        </h4>
        <p>{item.description}</p>
      </div>
    </div>
  </div>
))}
            </div>
                
        </div>


    </div>

    


   <div
  style={{
    width: "100%",
    maxWidth: "1100px",
    margin: "40px auto",
    padding: "45px 50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "45px",
    background: "#fff",
    borderRadius: "18px",
    border: "1px solid #eee",
    boxShadow: "0 10px 35px rgba(0,0,0,0.07)",
    boxSizing: "border-box",
  }}
>
  {/* LEFT */}
  <div
    style={{
      flex: "1",
      minWidth: "0",
    }}
  >
    <div
      style={{
        color: "#e94f70",
        fontSize: "14px",
        fontWeight: "700",
        letterSpacing: "1px",
        marginBottom: "12px",
      }}
    >
      THE SECRET'S OUT!
    </div>

    <h2
      style={{
        margin: "0 0 15px",
        fontSize: "42px",
        lineHeight: "1.15",
        fontWeight: "800",
        color: "#171717",
      }}
    >
      Refer and Earn{" "}
      <span style={{ color: "#e94f70" }}>₹15,000</span>
    </h2>

    <p
      style={{
        margin: "0 0 25px",
        color: "#666",
        fontSize: "16px",
        lineHeight: "1.6",
      }}
    >
      Earn ₹15,000 on every successful referral.
      <br />
      Share the opportunity and get rewarded.
    </p>

    <button
      onClick={() => setshowreferalmodal(true)}
      style={{
        background: "#e94f70",
        color: "#fff",
        border: "none",
        padding: "13px 26px",
        fontSize: "16px",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "600",
      }}
    >
      Refer Now →
    </button>
  </div>

  {/* RIGHT */}
  <div
    style={{
      flex: "0 0 42%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img
      src="assets/images/refer-and-earn-apps-in-india.webp"
      alt="Refer and Earn"
      style={{
        width: "100%",
        maxWidth: "400px",
        height: "auto",
        objectFit: "contain",
      }}
    />
  </div>
</div>

   
    {showreferal && (
        <>
         <div
      onClick={() => setshowreferalmodal(false)}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        zIndex: 999,
      }}
    ></div>

    
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        maxWidth: "420px",
        background: "#fff",
        borderRadius: "14px",
        padding: "30px",
        zIndex: 1000,
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
      }}
    >
      
      <div
        onClick={() => setshowreferalmodal(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "15px",
          cursor: "pointer",
          fontSize: "22px",
          color: "#777",
        }}
      >
        ✖
      </div>

      <h2
        style={{
          textAlign: "center",
          marginBottom: "10px",
          color: "#ef5b78",
        }}
      >
        Refer & Earn
      </h2>

      <p
        style={{
          textAlign: "center",
          color: "#555",
          marginBottom: "25px",
        }}
      >
        Enter your phone number to continue
      </p>

      <input
        type="number"
        placeholder="Enter Phone Number"
        value={phone}
        onChange={(e)=>setphone(e.target.value)}
        style={{
          width: "100%",
          padding: "14px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "16px",
          marginBottom: "20px",
          outline: "none",
        }}
      />

      <button
       onClick={onrefer}
        style={{
          width: "100%",
          background: "#ef5b78",
          color: "#fff",
          border: "none",
          padding: "14px",
          borderRadius: "8px",
          fontSize: "17px",
          cursor: "pointer",
          fontWeight: "600",
        }}
      >
        Submit
      </button>
    </div>
  </>
        
    )}
   
    <Footer />
   <div>
   
      <WhatsAppButton />
      <Chat/>
      <Call/>
    </div>
    
    
    </div>
    </>
);
}
export default Home;






